import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { GatedRoute } from '../../common';
import ForgotPasswordPage from '../../ForgotPasswordPage';
import PublicHomePage from '../../PublicHomePage';
import LoginFormPage from '../../LoginFormPage';
import RegistrationFormPage from '../../RegistrationFormPage';
import ResetPasswordPage from '../../ResetPasswordPage';
import { adminRoutes, userRoutes, getLoggedInRedirect } from '../routes';

function AppRoutes({ isAdmin, isLoggedIn }) {
  const loggedInRedirect = getLoggedInRedirect(isAdmin);

  return (
    <Switch>
      <GatedRoute
        component={PublicHomePage}
        exact
        hasAccess={!isLoggedIn}
        path="/"
        redirectTo={loggedInRedirect}
      />
      <GatedRoute
        component={LoginFormPage}
        hasAccess={!isLoggedIn}
        path="/login"
        redirectTo={loggedInRedirect}
      />
      <GatedRoute
        component={RegistrationFormPage}
        hasAccess={!isLoggedIn}
        path="/signup"
        redirectTo={loggedInRedirect}
      />
      <GatedRoute
        component={ForgotPasswordPage}
        hasAccess={!isLoggedIn}
        path="/forgot"
        redirectTo={loggedInRedirect}
      />
      <GatedRoute
        component={ResetPasswordPage}
        hasAccess={!isLoggedIn}
        path="/reset/:email/:token"
        redirectTo={loggedInRedirect}
      />
      {userRoutes.map(page => (
        <GatedRoute
          component={page.component}
          hasAccess={isLoggedIn && !isAdmin}
          key={page.route}
          path={page.route}
          redirectTo="/login"
        />
      ))}
      {adminRoutes.map(page => (
        <GatedRoute
          component={page.component}
          hasAccess={isLoggedIn && isAdmin}
          key={page.route}
          path={page.route}
          redirectTo="/login"
        />
      ))}
    </Switch>
  );
}

AppRoutes.propTypes = {
  isAdmin: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
};

AppRoutes.defaultProps = {
  isAdmin: false,
  isLoggedIn: false,
};

export default AppRoutes;



// WEBPACK FOOTER //
// ./src/modules/App/components/AppRoutes.js